import React from "react";
import {
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Scatter,
  ResponsiveContainer,
} from "recharts";

/* const data = [
  { index: 10000, blue: 790 },
  { index: 1666, blue: 42 },
  { index: 625,  blue: 11 },
  // Calculation of line of best fit is not included in this demo
  { index: 600, blueLine: 0 },
  { index: 10000, blueLine: 678 },
]; */

export default function ScatterAndLineOfBestFit({
  data,
  xId,
  xLabel,
  yId,
  yLabel,
  maxXValue,
}) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 20,
          right: 80,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid />
        <XAxis
          dataKey={xId}
          type="number"
          label={{ value: xLabel, position: "insideBottom", offset: -10 }}
          domain={[0, maxXValue]}
        />
        <YAxis
          type="number"
          label={{ value: yLabel, angle: -90, position: "insideLeft", dy: 50 }}
        />
        <Scatter name="grey" dataKey={yId} fill="grey" stroke="white" />
        <Line
          dataKey="correlationLine"
          stroke="grey"
          dot={false}
          activeDot={false}
          legendType="none"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
